import React from 'react';

import {Comment, FromServerProtocol} from 'notebook/ELNConstants';
import Commentable from 'notebook/protocols/viewer/Commentable';
// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import Material from 'notebook/protocols/viewer/Material';

interface Props {
  materials: FromServerProtocol['materials'];
  commentBus: CommentBus;
  commentReplies: Array<Comment>;
  comments: Array<Comment>;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class MaterialsList extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <ul className="materials-list">
        {this.props.materials.map((material) => (
          <Commentable
            key={material.id}
            linkableID={material.id}
            linkType={material.link_type}
            commentBus={this.props.commentBus}
            commentReplies={this.props.commentReplies}
            comments={this.props.comments.filter((comment) => comment.item_id === material.id)}
          >
            <Material
              key={material.id}
              components={material.components}
              name={material.name}
              formats={material.formats}
            />
          </Commentable>
        ))}
      </ul>
    );
  }
}
